import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { KeyValue } from '@angular/common';

import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { timeout, catchError, map, finalize } from 'rxjs/operators';

import { environment as env } from 'src/environments/environment';

import { NgxSpinnerService } from 'ngx-spinner';
import { TokenService } from '../token/token.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';



@Injectable({
    providedIn: 'root'
})
export class HttpService {

    constructor(
        private http: HttpClient,
        private token: TokenService,
        private spinner: NgxSpinnerService,
        private router: Router,
        protected translate: TranslateService
    ) { }

    public post(type: string, controller: string, action: string, payload?: any, showSpinner: boolean = true): Observable<any> {

        const endPoint = this.getEndPoint(type, controller, action);

        const token: string | null = this.token.getLocalToken(env.TokenKeys.AccessToken);
        const lang: string | null = this.token.getLocalToken(env.TokenKeys.Language);
        const header: HttpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            // 'lang': lang ? lang : 'en'
        });


        if (!env.Production) {
            // console.log('http post endpoint:', endPoint);
            // console.log('http post payload:', payload);
        }

        if (showSpinner === true) {
            this.spinner.show();
        }

        return this.http.post(endPoint, payload, { headers: header })
            .pipe(
                map((m: any) => {
                    if (!env.Production) {
                        // console.log('api return', m);
                    }
                    return m;
                }),
                timeout(env.ApiConfig.Timeout),
                catchError(this.handleError()),
                finalize(() => {
                    if (showSpinner === true) {
                        this.spinner.hide();
                    }
                })
            );
    }

    public postWithFile(type: string, controller: string, action: string, payload?: any): Observable<any> {
        const endPoint = this.getEndPoint(type, controller, action);

        const token: string | null = this.token.getLocalToken(env.TokenKeys.AccessToken);
        const lang: string | null = this.token.getLocalToken(env.TokenKeys.Language);
        const header: HttpHeaders = new HttpHeaders({
            // 'lang': lang ? lang : 'en'
        });


        if (!env.Production) {
            // console.log('http post endpoint:', endPoint);
            // console.log('http post payload:', payload);
        }

        this.spinner.show();
        return this.http.post(endPoint, payload, { headers: header })
            .pipe(
                map((m: any) => {
                    if (!env.Production) {
                        // console.log('api return', m);
                    }
                    return m;
                }),
                timeout(env.ApiConfig.Timeout),
                catchError(this.handleError()),
                finalize(() => this.spinner.hide())
            );
    }

    public get(type: string, controller: string, action: string, params?: KeyValue<string, any>[]): Observable<any> {

        let endPoint = this.getEndPoint(type, controller, action);

        const queryString: string = params ? params.map(i => {
            return `${encodeURIComponent(i.key)}=${encodeURIComponent(i.value)}`;
        }).join('&') : '';

        endPoint += queryString !== '' ? `?${queryString}` : '';

        const token: string | null = this.token.getLocalToken(env.TokenKeys.AccessToken);
        const lang: string | null = this.token.getLocalToken(env.TokenKeys.Language);
        const httpHeaders: HttpHeaders = new HttpHeaders({
            'Authorization': 'bearer ' + token,
        });

        //const options = { headers: httpHeaders, params: httpParams };
        const options = { headers: httpHeaders };

        if (!env.Production) {
            // console.log('http get endpoint:', endPoint);
            // console.log('http get options:', options);
        }

        this.spinner.show();
        return this.http.get(endPoint, options)
            .pipe(
                map((m: any) => {
                    if (!env.Production) {
                        // console.log('api return', m);
                    }
                    return m;
                }),
                timeout(env.ApiConfig.Timeout),
                catchError(this.handleError()),
                finalize(() => this.spinner.hide())
            );
    }

    private handleError<T>(result?: T) {
        return (err: any): Observable<T> => {
            if (!env.Production) {
                // console.log('http error:', err);
            }

            const code: number = err.error?.Code ? err.error?.Code : err.message;

            if (code === 401) {
                this.unAuthorized();
            }

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    private unAuthorized(): void {
        this.token.removeLocalToken(env.TokenKeys.AccessToken);
        this.router.navigate(['']);
    }


    private getEndPoint(type: string, controller: string, action: string) {
        let endPoint: string = '';

        switch (type) {
            case 'system':
                endPoint = env.ApiConfig.SystemUrl;
                break;
            case 'merchant':
                endPoint = env.ApiConfig.MerchantUrl;
                break;
            case 'admin':
                endPoint = env.ApiConfig.AdminUrl;
                break;
            case 'auth':
                endPoint = env.ApiConfig.AuthUrl;
                break;
            case 'content':
                endPoint = env.ApiConfig.ContentUrl;
                break;
            case 'unagent':
                endPoint = env.ApiConfig.UnAgentUrl;
                break;
            case 'member':
                endPoint = env.ApiConfig.MemberUrl;
                break;
            case 'awcgame':
                endPoint = env.ApiConfig.AwcGameUrl;
                break;
            case 'win16game':
                endPoint = env.ApiConfig.Win16GameUrl;
                break;
            default:
                throw new Error('Invalid API type specified');
        }

        return endPoint += `/api/${controller}/${action}`;
    }
}
